import { Controller } from "@hotwired/stimulus"
import { rememberPhotoPreview } from "photo_preview"

export default class extends Controller {
  static values = { url: String, srcset: String, sizes: String }

  remember(event) {
    const link = event.target.closest("a")
    if (!link || event.target.closest("button") || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === "_blank") return

    rememberPhotoPreview(this.element.querySelector("img[data-photo-id]"), link.pathname)
  }

  schedule({ pointerType }) {
    if (pointerType !== "mouse" || navigator.connection?.saveData || this.preloadedImage) return

    this.cancel()
    this.timer = setTimeout(() => {
      const image = new Image()
      this.preloadedImage = image
      image.onerror = () => { this.preloadedImage = null }
      image.fetchPriority = "low"
      image.sizes = this.sizesValue
      image.srcset = this.srcsetValue
      image.src = this.urlValue
    }, 150)
  }

  cancel() {
    clearTimeout(this.timer)
  }

  disconnect() {
    this.cancel()
  }
}
